import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MaterialModule } from 'src/app/material.module';
import { OrderNotesEdit } from './components/order-notes/component';
import { OrderApiService } from './services/order-api-service';
import { DirectivesModule } from '../directives/module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    DirectivesModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [OrderNotesEdit],
  providers: [OrderApiService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [],
})
export class OrderModule {}
